// extracted by mini-css-extract-plugin
module.exports = {"key":"live-conversations__Key__key"};